<div class="input-container">
  <input [type]="fieldTextType ? 'text' : 'password'" class="search-input" [class.submitted]="submitted"
    [ngClass]="{'is-invalid': submitted && formControl.invalid}" [formControl]="formControl"
    [placeholder]="placeHolder" />


  <div class="auth-icons">
    <!-- New #4: show the clear icon whenever there is something to clear. It was
         bound to error state (submitted && hasPasswordError()), so a field that
         became VALID lost its clear button - typing one character into Temp
         Password or Re-enter satisfied their only validator (required) and the X
         vanished. Password kept its X purely because passwordValidator() was
         still failing, which is what made the repro look inconsistent.
         Content-presence is the conventional binding for a clear affordance, and
         it also removes the old oddity of offering "clear" on an empty field. -->
    <i class="bi bi-x-circle-fill" [class.icon-hidden]="!formControl.value"
      style="margin-left: 10px;" (click)="clearInput()"></i>

    <button type="button" class="eye-toggle-btn" (click)="toggleFieldTextType()" style="margin-left: 10px;">
      <i [ngClass]="{
              'bi-eye-fill': !fieldTextType,
              'bi-eye-slash-fill': fieldTextType,
            }"></i>
    </button>
    <i class="bi bi-check-circle-fill" [class.icon-hidden]="!(submitted && !formControl.errors)"
      style="margin-left: 10px; color: green;"></i>
  </div>
</div>
<!-- Always-visible policy hint. The rules used to appear NOWHERE on the form, so
     a rejected password produced a disabled button and no explanation. Sourced
     from the validator module so copy and rule cannot drift apart. -->
<div *ngIf="showRequirements" class="rap-hint-text">{{ requirementsHint }}</div>

<div *ngIf="showErrors" class="rap-error-text">
  <div *ngIf="formControl.errors?.['required']">Password is required</div>

  <div *ngIf="formControl.errors?.['minlength']">Password must be at least 8 characters long.</div>

  <!-- Names the rule that actually failed instead of reprinting the whole policy,
       so "which part is wrong?" is answerable at a glance. -->
  <ng-container *ngIf="strengthFailures as f">
    <div *ngIf="f.minLength">Password must be at least 8 characters long.</div>
    <div *ngIf="f.maxLength">Password must be 256 characters or fewer.</div>
    <div *ngIf="f.uppercase">Password must include an uppercase letter.</div>
    <div *ngIf="f.lowercase">Password must include a lowercase letter.</div>
    <div *ngIf="f.number">Password must include a number.</div>
    <div *ngIf="f.symbol">Password must include a symbol.</div>
  </ng-container>

  <div *ngIf="formControl.errors?.['passwordsMismatch']">
    Passwords do not match.
  </div>

</div>